module.exports = __webpack_public_path__ + "img/03.sunrise-light.48ad9944.svg";